// Status for GET and POST /api/recon_file_backfills. The body is { data: Status }.

export function readBackfillStatus(body) {
	if (!body || body.data === null || typeof body.data !== 'object') return null;
	return body.data;
}

export function canSeeReconFileBackfill(position) {
	return position === 'admin' || position === 'super_admin';
}

export function backfillIsRunning(state) {
	return state === 'scanning' || state === 'copying';
}

export function backfillButtonEnabled(state) {
	return state === 'idle'
		|| state === 'finished'
		|| state === 'finished_with_failures'
		|| state === 'failed';
}

// Completion is state, not finished_at. Progress is only shown while copying.
export function backfillProgress(status) {
	if (!status || status.state !== 'copying') return null;
	if (typeof status.found !== 'number' || !status.found) return null;
	const done = (Number(status.migrated) || 0) + (Number(status.failed) || 0);
	return Math.min(100, Math.round((done / status.found) * 100));
}

// Scanning has no total yet. Copying uses migrated + failed over found.
// The poll is the only progress source; the worker does not stream bytes.
export function backfillProgressBar(status) {
	if (!status || !backfillIsRunning(status.state)) return null;
	const percent = backfillProgress(status);
	if (percent === null) return { indeterminate: true, percent: null };
	return { indeterminate: false, percent };
}

export function backfillView(status) {
	const state = status && status.state;
	if (state === 'scanning') {
		return {
			title: 'Finding files on the public file server…',
			counts: false,
			emphasizeFailed: false,
			detail: '',
		};
	}
	if (state === 'copying') {
		const fileError = status && status.error;
		return {
			title: 'Copying files',
			counts: true,
			emphasizeFailed: Number(status && status.failed) > 0,
			detail: fileError || '',
			detailDanger: !!fileError,
		};
	}
	if (state === 'finished') {
		return {
			title: 'Copy finished',
			counts: true,
			emphasizeFailed: false,
			detail: 'Running it again skips files already copied.',
		};
	}
	if (state === 'finished_with_failures') {
		return {
			title: 'Copy finished',
			counts: true,
			emphasizeFailed: true,
			detail: '',
		};
	}
	if (state === 'failed') {
		const scanError = status && status.error;
		return {
			title: '',
			counts: false,
			emphasizeFailed: false,
			detail: scanError || '',
			detailDanger: !!scanError,
		};
	}
	return {
		title: 'Not started',
		counts: false,
		emphasizeFailed: false,
		detail: '',
	};
}
